import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {HomeComponent} from './home/home.component';
import {DriversComponent} from './drivers/drivers.component';
import {BusComponent} from './bus/bus.component';
import {TripLineComponent} from './trip-line/trip-line.component';
import {SubscriptionComponent} from './subscription/subscription.component';
import {NewsComponent} from './news/news.component';
import {TestComponent} from './test/test.component';
import {AllNewsComponent} from './all-news/all-news.component';
import {LoginComponent} from './login/login.component';
import {SettingsComponent} from './settings/settings.component';
import {LiveLocationComponent} from './live-location/live-location.component';
import {SisCodeComponent} from './sis-code/sis-code.component';
import {MangeTravelComponent} from './mange-travel/mange-travel.component';
import {HomePageComponent} from './home-page/home-page.component';
import {PrivacyComponent} from './privacy/privacy.component';

const routes: Routes = [
  {path: '', component: HomePageComponent},
  {path: 'privacy', component: PrivacyComponent},
  {path: 'home', component: HomeComponent},
  {path: 'login', component: LoginComponent},
  {path: 'drivers', component: DriversComponent},
  {path: 'bus', component: BusComponent},
  {path: 'trip-line', component: TripLineComponent},
  {path: 'subscription', component: SubscriptionComponent},
  {path: 'news-info', component: NewsComponent},
  {path: 'news-info/:id', component: NewsComponent},
  {path: 'all-news', component: AllNewsComponent},
  {path: 'test', component: TestComponent},
  {path: 'settings', component: SettingsComponent},
  {path: 'tracking', component: LiveLocationComponent},
  {path: 'sis-code', component: SisCodeComponent},
  {path: 'mange-travel', component: MangeTravelComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
